export default {
  menu: 'Documents',
  title: 'Documents',

  general: {
    notifications: {
      delete: {
        success: 'Document information successfully deleted',
        error: 'Deleting document information successfully deleted'
      }
    }
  },

  document: {
    title: 'Document',
    dynamicTitle: 'Document No. {id}',

    table: {
      header: {
        rowNumber: 'Row',
        description: 'Description',
        debt: 'Debtor',
        credit: 'Creditor'
      }
    }
  },

  print: {
    cost: {
      costReceipt: 'Receipt of expenses',
      date: 'Date:',
      docNumber: 'Document number:',
      nameAndSignature: 'Name and signature',
      receiver: 'Receiver',
      payer: 'Payer',
      confirmer: 'Endorser',
      print: 'Print',
      back: 'Back',
      bank: 'Bank',
      cashBox: 'Cash register',
      paymentGateway: 'Payment gateway',

      description: {
        confirm: 'This is confirmed',
        price: 'price (in number): ',
        toText: '(in words) : ',
        account: 'To the account ',
        inDate: 'in date ',
        description: 'for ',
        payer: 'by ',
        payed: 'Was paid'
      }
    },

    receive: {
      receiveReceipt: 'The receipt of funds',
      date: 'Date:',
      docNumber: 'Document number:',
      nameAndSignature: 'Name and signature',
      receiver: 'Receiver',
      payer: 'Payer',
      confirmer: 'Endorser',
      print: 'Print',
      back: 'Back',
      bank: 'Bank',
      cashBox: 'Cash register',
      paymentGateway: 'Payment gateway',
      transactionId: 'Transaction number:',
      paymentConfirm: 'Payment confirmation:',

      description: {
        confirm: 'This is confirmed',
        price: 'price (in number): ',
        toText: '(in words): ',
        payee: 'from mr./ms. ',
        inDate: 'in date ',
        description: 'for ',
        payer: 'by ',
        payed: 'received'
      }
    },

    payment: {
      paymentReceipt: 'Receipt of payment',
      date: 'Date:',
      docNumber: 'Document number:',
      nameAndSignature: 'Name and signature',
      receiver: 'Receiver',
      payer: 'Payer',
      confirmer: 'Endorser',
      print: 'Print',
      back: 'Back',
      bank: 'Bank',
      cashBox: 'Cash register',
      paymentGateway: 'Payment gateway',

      description: {
        confirm: 'This is confirmed',
        price: 'price (in number): ',
        toText: '(in words): ',
        payee: 'to mr./ms. ',
        inDate: 'in date ',
        description: 'for ',
        payer: 'by ',
        payed: 'Was paid'
      }
    },

    internalTransfer: {
      internalTransferReceipt: 'Treasury transfer receipt',
      date: 'Date:',
      docNumber: 'Document number:',
      nameAndSignature: 'Name and signature',
      receiver: 'Receiver',
      payer: 'Payer',
      confirmer: 'Endorser',
      print: 'Print',
      back: 'Back',
      bank: 'Bank',
      cashBox: 'Cash register',
      paymentGateway: 'Payment gateway',

      description: {
        confirm: 'This is confirmed',
        price: 'price (in number): ',
        toText: '(in words): ',
        inDate: 'in date ',
        description: 'for ',
        payer: 'by ',
        payee: 'to ',
        payed: 'Was paid'
      }
    }
  },

  list: {
    title: 'Documents',

    table: {
      header: {
        id: 'Document number',
        createdAt: 'Date',
        creator: 'Creator',
        description: 'Documents',
        type: 'Type'
      },

      filters: {
        type: {
          all: 'All'
        }
      }
    },

    confirmation: {
      deleteDocument: {
        title: 'Confirm Delete Document',
        body: 'Are you sure you want to delete this document completely?'
      }
    },

    types: {
      manual: 'Manual',
      receive: 'Receive',
      payment: 'Payment',
      withdrawal: 'Withdrawal',
      internal_fund_transfer: 'Transfer',
      revenue: 'Revenue',
      cost: 'Cost',
      beginning_inventory: 'Beginning Inventory',
      payroll: 'Payroll',
      purchase: 'Purchase',
      return_purchase: 'Purchase Refund',
      sale: 'Sale',
      return_sale: 'Sale Refund',
      warehouse_receipt: 'Pull in',
      warehouse_requisition: 'Pull out',
      inventory_transfer: 'Inventory Transfer',
      inventory_deficit: 'Warehouse deficit',
      storeroom_surplus: 'Warehouse surplus',
      sale_cooperation: 'Sale cooperation',
      purchase_adjustment: 'Voided purchase',
      return_purchase_adjustment: 'Voided purchase refund',
      sale_adjustment: 'Voided sale',
      sale_cooperation_adjustment: 'Voided sale cooperation',
      return_sale_adjustment: 'Voided sale refund',
      receive_adjustment: 'Voided receive',
      payment_adjustment: 'Voided payment',
      cost_adjustment: 'Voided cost'
    }
  },

  insert: {
    title: 'Add Document',
    dynamicTitle: 'Add Receipt / Payment Document',

    labels: {
      documentType: 'Document type',
      receive: 'Receive',
      payment: 'Payment',
      paymentTo: 'Payment to',
      receiveFrom: 'Receive from',
      withdrawalFrom: 'Withdrawal from',
      depositTo: 'Deposit to',
      price: 'Amount',
      cashBox: 'Cashier',
      bank: 'Bank',
      depositType: 'Deposit type',
      choose: 'Choose',
      pos: 'POS',
      cardToCard: 'Card to Card',
      shaba: 'IBAN'
    },

    notifications: {

      receive: {
        insert: {
          success: 'Receipt document created successfully',
          error: 'Creating a receive document has error'
        }
      },

      payment: {
        insert: {
          success: 'Payment document created successfully',
          error: 'Creating a payment document has error'
        }
      },

      parseError: {
        user: 'User not selected',
        cashBox: 'Cash is not selected',
        bank: 'Bank not selected',
        price: 'Amount not entered',
        depositTo: 'Deposit to bank or fund is not specified',
        depositType: 'Deposit type not specified',
        withdrawalFrom: 'Withdrawal from bank or fund not specified'
      }
    }
  }
}
